import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from '../ui/alert-dialog';
import { Button } from '../ui/button';
import { Trash2 } from 'lucide-react';

/**
 * Header CTA that wipes the entire Calculator surface:
 *   - map shapes + measurement totals
 *   - all panel inputs (roof, siding, gutter, driveway, deck, fence,
 *     pest_control, lawn_care)
 *   - manualOverride flags
 *   - calculations
 *   - recurring plan + prepay package
 *   - selected address
 *
 * Client info is intentionally preserved.
 */
const ClearCalculatorButton = ({ onClear }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="text-rose-600 border-rose-300 hover:bg-rose-50 hover:text-rose-700"
        data-testid="calc-clear-calculator-btn"
      >
        <Trash2 className="h-4 w-4 mr-2" />
        Clear Calculator
      </Button>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="calc-clear-confirm-modal">
          <AlertDialogHeader>
            <AlertDialogTitle>Clear Calculator?</AlertDialogTitle>
            <AlertDialogDescription>
              This will clear all measurements, inputs, and calculations.
              Client info will stay.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <Button
              variant="ghost"
              onClick={() => setOpen(false)}
              data-testid="calc-clear-cancel"
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={() => { setOpen(false); onClear?.(); }}
              data-testid="calc-clear-confirm"
            >
              Clear Everything
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ClearCalculatorButton;
